import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { NotificationProvider } from './context/NotificationContext';

import Employees from './pages/Employees';
import SalaryStatus from './pages/SalaryStatus';
import Attendance from './pages/Attendance';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Menu from './pages/Menu';
import Orders from './pages/Orders';

function App() {
  return (
    <NotificationProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="menu" element={<Menu />} />
            <Route path="employees" element={<Employees />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="reports" element={<Reports />} />
            <Route path="salary" element={<SalaryStatus />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Router>
    </NotificationProvider>
  );
}

export default App;
